// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1suZW","inputDescription":"styles_inputDescription__3KN4M"};